function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8,4.5 C10.2927278,4.5 12.3718932,5.79496859 13.9061062,7.90087641 C14.0312979,8.07320099 14.0312979,8.31394858 13.9061062,8.48627316 C12.3718932,10.5896468 10.2927278,11.8846154 8,11.8846154 C5.70727217,11.8846154 3.62810678,10.5896468 2.09389383,8.48373898 C1.96870206,8.31141439 1.96870206,8.07066681 2.09389383,7.89834222 C3.62810678,5.79496859 5.70727217,4.5 8,4.5 Z M7.99753329,5.58692687 L7.83553237,5.59223378 C6.57870512,5.6733277 5.55998773,6.72501452 5.48143602,8.02251729 C5.38570114,9.59624624 6.64252838,10.8912148 8.16446763,10.7923816 C9.41884014,10.7087535 10.4375575,9.65706668 10.518564,8.36209809 C10.6108798,6.84457375 9.44551979,5.58625388 7.99753329,5.58692687 L7.99753329,5.58692687 Z M9.35747162,8.28100417 C9.31328628,8.98297344 8.76342436,9.54809672 8.08837067,9.59117787 C7.26848727,9.64439576 6.59097883,8.94749485 6.64498312,8.10107703 C6.68671372,7.40164194 7.23657564,6.83651866 7.91408407,6.79090333 C8.73396747,6.73768544 9.41147591,7.43458635 9.35747162,8.28100417 Z"
});
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.e5ebfdac692c4518d285c071afa2180e.svg";
export { ForwardRef as ReactComponent };